module.exports = __webpack_public_path__ + "media/images/stroke-1@3x-b0a1e5359b6f3a3892d6e1659307bab8.png";